/**
 * Shared validation for ecommerce SKU values (API `ecommerce_sku`, GraphQL `ecommerceSku`).
 * @module services/plans/ecommerceSkuFormat
 */

/** Letters, numbers, dashes, and underscores only (non-empty values). */
export const ECOMMERCE_SKU_ALLOWED_PATTERN = /^[A-Za-z0-9_-]+$/

export const ECOMMERCE_SKU_FORMAT_MESSAGE =
  'E-commerce SKU may only contain letters, numbers, dashes, and underscores'

/**
 * @param {string | null | undefined} value
 * @returns {boolean} True if empty/null/undefined or matches {@link ECOMMERCE_SKU_ALLOWED_PATTERN}.
 */
export function isEcommerceSkuFormatValid (value) {
  if (value == null || value === '') {
    return true
  }
  return ECOMMERCE_SKU_ALLOWED_PATTERN.test(value)
}
